import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Container, Stack, TextField } from "@mui/material";
import axios from "axios";
import * as CSS from "csstype";
import { useState, useEffect } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import { API_URL } from "../../Const";
import { useLoadingOverlay } from "../../utilHooks/loadingOverlay";
import dokodemo_logo from "../../logo-dokodemo.png";

// フォームの型
interface PasswordResetFormInput {
  email: string;
}

// バリデーションルール
const schema = yup.object({
  email: yup
    .string()
    .required("必須項目です")
    .email("正しいメールアドレス形式で入力してください")
    .max(50, "50文字以内で入力してください。"),
});

// メイン処理
function App() {
  const { openLoading, closeLoading } = useLoadingOverlay();

  const titleStyle: CSS.Properties = {
    fontSize: "40px",
    fontWeight: "700",
    color: "#e15f5f",
    margin: "0",
    textAlign: "center",
  };
  const subTitleStyle: CSS.Properties = {
    fontSize: "16px",
    fontWeight: "600",
    color: "#646464",
    margin: "10px",
    textAlign: "center",
  };
  const msgStyle: CSS.Properties = {
    fontSize: "16px",
    fontWeight: "600",
    color: "#646464",
    margin: "12px",
    textAlign: "left",
  };
  const alertMsgStyle: CSS.Properties = {
    fontSize: "16px",
    fontWeight: "600",
    color: "#ff6347",
    margin: "10px",
    textAlign: "center",
  };

  const getState = (state: any, name: string): string =>
    (state as any)?.[name] ?? "";
  const history = useHistory();
  const err = getState(history.location.state, "err");
  const [msg1, setMsg1] = useState("");
  const [msg2, setMsg2] = useState("");
  const [msgFlg, setMsgFlg] = useState(false);

  //バリデーション設定
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<PasswordResetFormInput>({
    resolver: yupResolver(schema),
  });

  // ボタン押下時の処理
  const onSubmit: SubmitHandler<PasswordResetFormInput> = (data) => {
    openLoading();
    axios
      .post(API_URL.USER_SEND_CODE, {
        user_id: data.email,
      })
      .then((res) => {
        // setMsg1(res.data.data)
        // setMsg1(submitMsg)
        setMsgFlg(true);
        // setMsg2("メールが届かない場合や紛失した場合は再度送信してください")
      })
      .catch((error) => {
        setMsg1("時間をおいてから再度お試しください");
        setMsg2("再送信できない場合はお問い合わせください");
      })
      .finally(() => {
        closeLoading();
      });
  };

  useEffect(() => {
    console.log("use Effect");
  }, []);

  return (
    <Container maxWidth="sm" sx={{ pt: 5 }}>
      <Stack spacing={3} margin={5}>
        <img src={dokodemo_logo} alt="Logo" />
        <p style={subTitleStyle}>
          初回登録時に利用したメールアドレスを入力して
          <br />
          「リセットメール送信」ボタンを押してください。
          <br />
          <br />
          登録メールアドレス宛にパスワードリセットの
          <br />
          案内メールが送信されます。
          <br />
        </p>
        <h4 style={{ color: "red" }}>{err}</h4>

        <TextField
          required
          label="メールアドレス"
          type="email"
          {...register("email")}
          error={"email" in errors}
          helperText={errors.email?.message}
          onInput={(e) => {
            console.log(e.target);
          }}
          onChange={(e) => {
            console.log(e.target.value);
          }}
          onKeyDown={(e) => {
            console.log(e.target);
          }}
          onFocus={(e) => {
            console.log(e.target);
          }}
        />
        <Button
          color="primary"
          variant="contained"
          size="large"
          onClick={handleSubmit(onSubmit)}
        >
          リセットメール送信
        </Button>
        {msgFlg ? (
          <p style={msgStyle}>
            入力頂いたメールアドレス宛に
            <br />
            パスワードリセットの案内メールを送信しました。
            <br />
            <br />
            ※パスワードリセットの有効期限は24時間です。
            <br />
            有効期限を過ぎると、最初から手続きが必要となります。
            <br />
            <br />
            ※迷惑メールの設定をされている方
            <br />
            「no-reply@verificationemail.com」を
            <br />
            受信できるように設定をお願い致します。
            <br />
            <br />
            ※登録中のメールアドレスが使用できない方
            <br />
            ドメイン変更などにより、登録アドレスが使用できない場合
            <br />
            契約時の担当者へ直接ご連絡をお願い致します。
            <br />
          </p>
        ) : (
          <></>
        )}
        {/* <p style={alertMsgStyle} >{msg2}</p> */}
      </Stack>
    </Container>
  );
}

export default App;
